import { defineStore } from 'pinia'
import { useFetch } from '@/modules/core/composables/useFetch'
import { Call } from './better-entity-store'

///////////////////////////////////////////////////////////////////////////////
// Store
///////////////////////////////////////////////////////////////////////////////

export const useCallStore = defineStore('investing/callStore', () => {
  const generateInvoice = async (id: string, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/investing/calls/${id}/generate-invoice`).post()
  }

  const removeCall = async (id: string, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/investing/calls/${id}/remove`).post()
  }

  const sendInvoiceReminder = async (id: string, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/investing/calls/${id}/send-invoice-reminder`).post()
  }

  const fetchCall = async (id: string, { slug }: { slug: string }) => {
    return await useFetch(`/v4/${slug}/investing/calls/${id}`).get<Call>()
  }

  return {
    generateInvoice,
    removeCall,
    sendInvoiceReminder,
    fetchCall,
  }
})
